export default __webpack_public_path__ + "static/media/ticketSold.cd0671b2.svg";